import { HttpService } from './http-service';

export class HelpService {
	public static readonly id = 'help-service';

	public constructor(private readonly _httpService: HttpService) {}

	public async getRaw(): Promise<string> {
		const response = await this._httpService.getRaw('api/help');
		return response;
	}
}
